<div class="pagecenter-component-container">
    <div *ngIf="channels$ | async as channels; else loadingWidget" class="pagecenter-filter mb-4">
        <app-page-filter class="filter-panel"
                         [channels]='channels'
                         [editorOptionsEnabled]='editorOptionsEnabled'
                         [pageType]='pageType'
                         (queryOptionsChange)='queryOptionsChanged$.next($event)'
                         (channelOptionsChange)='channelFilterChanged$.next($event)'></app-page-filter>
    </div>
    <!-- List of pages -->
    <div class="row">
        <div *ngIf="filteredPages$ | async as pages; else loadingWidget" class="col pagecenter-list">
            <app-page-list [pages]='pages'
                           [pageType]='pageType'
                           [loading]='loading'
                           [editorOptionsEnabled]='editorOptionsEnabled'
                           [showSharePointExternalIcon]='lightEnabled'
                           (deleteEvent)="deletePage($event)">
            </app-page-list>
        </div>
    </div>

    <div class="row justify-content-center mt-4" *ngIf="!loading && amountOfPagesMatchingFilter > amountOfPagesToDisplayCurrently">
        <div class="col-auto">
            <button mat-flat-button color="accent" class="news-show-more-btn" (click)="showMorePages()">
                <span i18n="@@page-center-show-more">Show more</span>
                <i class="ml-2 ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i>
            </button>
        </div>
    </div>

    <div class="row justify-content-center mt-4" *ngIf="!loading && fetchedAmountOfPages < amountOfPagesToDisplayCurrently && fetchedAmountOfPages > amountOfPagesToDisplay">
        <div class="col-auto">
            <button mat-flat-button color="accent" class="news-show-more-btn" (click)="showLessPages()">
                <span i18n="@@page-center-show-less">Show less</span>
                <i class="ml-2 ms-Icon ms-Icon--ChevronUp" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</div>

<ng-template #loadingWidget>
    <div>
        <app-widget-placeholder></app-widget-placeholder>
    </div>
</ng-template>
